export type CustomContentDto = {
    Language: string;
    Type: CustomContentType | string;
    Content: string;
};

export const CustomContentSection = {
    Promotion: 'promo',
    PromotionBonus: 'promoBonus',
    WelcomeOffer: 'welcomeOffer',
    Bonus: 'bonus',
} as const;
export type CustomContentSection = typeof CustomContentSection[keyof typeof CustomContentSection];

export const PromotionCustomContentConditions = {
    promoBetEligibility: 'promoBetEligibility',
    promoMinDepositsNumber: 'promoMinDepositsNumber',
    promoMinDepositMinValue: 'promoMinDepositMinValue',
    promoMinDepositMaxValue: 'promoMinDepositMaxValue',
    promoMinWageringValue: 'promoMinWageringValue',
    promoWageringTimeframe: 'promoWageringTimeframe',
    promoMinNetWin: 'promoMinNetWin',
    promoNetWinTimeframe: 'promoNetWinTimeframe',
    promoMinNetLoss: 'promoMinNetLoss',
    promoNetLossTimeframe: 'promoNetLossTimeframe',
    promoPaymentMethod: 'promoPaymentMethod',
    promoBetType: 'promoBetType',
    promoMinOdd: 'promoMinOdd',
} as const;
export type PromotionCustomContentConditions = typeof PromotionCustomContentConditions[keyof typeof PromotionCustomContentConditions];

export const BonusCustomContentConditions = {
    bonusBetEligibility: 'bonusBetEligibility',
    bonusMinTicketEvents: 'bonusMinTicketEvents',
    bonusMinEventOdd: 'bonusMinEventOdd',
    bonusMinMultipleTicketOdd: 'bonusMinMultipleTicketOdd',
    bonusMinEventOddInMultiple: 'bonusMinEventOddInMultiple',
    bonusWageringContribution: 'bonusWageringContribution',
    bonusBetType: 'bonusBetType',
    bonusTicketType: 'bonusTicketType',
} as const;
export type BonusCustomContentConditions = typeof BonusCustomContentConditions[keyof typeof BonusCustomContentConditions];

export const SharedCustomContentConditions = {
    sharedBetTotalOff: 'sharedBetTotalOff',
    sharedBetsMustSettle: 'sharedBetsMustSettle',
    sharedExpirationDate: 'sharedExpirationDate',
    sharedFreeSpinUsage: 'sharedFreeSpinUsage',
    sharedBingoUsage: 'sharedBingoUsage',
    sharedTermsAndConditions: 'sharedTermsAndConditions',
    sharedDefault: 'sharedDefault',
} as const;
export type SharedCustomContentConditions = typeof SharedCustomContentConditions[keyof typeof SharedCustomContentConditions];

export type CustomContentConditions =
    | PromotionCustomContentConditions
    | BonusCustomContentConditions
    | SharedCustomContentConditions;

export const CustomContentType = {
    ...PromotionCustomContentConditions,
    ...BonusCustomContentConditions,
    promoImage: 'promoImage',
    promoBonusTitle: 'promoBonusTitle',
    promoBonusValueString: 'promoBonusValueString',
    promoTerms: 'promoTerms',
    bonusEligibilityTitle: 'bonusEligibilityTitle',
    bonusButtonCtaText: 'bonusButtonCtaText',
    bonusButtonCtaUrl: 'bonusButtonCtaUrl',
    promoButtonCtaText: 'promoButtonCtaText',
    promoButtonCtaUrl: 'promoButtonCtaUrl',
} as const;
export type CustomContentType = typeof CustomContentType[keyof typeof CustomContentType];
